import {
	deleteUserSoft,
	getUserData,
} from '@dealstack/frontend/shared/dataExchange/services/god.service';
import { logger } from '@dealstack/frontend/shared/mechanism/logger/logger';
import { useDSToast } from '@dealstack/frontend/shared/mechanism/toast/useDSToast';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

export const useUserController = () => {
	const toastApi = useDSToast();
	const [showSoftDeleteConfirmationModal, setShowSoftDeleteConfirmationModal] = useState(false);
	const { userId } = useParams();
	const getUserDataRequest = useQuery({
		queryKey: [formatUnicorn(API_PATHS.GODMODE_USER_USERID_GET, { userId: userId || '' })],
		queryFn: ({ signal }) =>
			getUserData(
				formatUnicorn(API_PATHS.GODMODE_USER_USERID_GET, { userId: userId || '' }),
				signal
			),
		meta: { suppressErrorToast: true },
	});
	const deleteUserSoftDelete = useMutation({
		mutationFn: deleteUserSoft,

		onError: (error) => {
			logger.error(error);
		},
	});

	const refreshData = useCallback(() => getUserDataRequest?.refetch(), []);

	const handleSoftDelete = () => {
		if (!userId) {
			return;
		}
		deleteUserSoftDelete.mutate(userId, {
			onSuccess: () => {
				toastApi.success({
					message: 'User has been soft deleted',
				});
				void refreshData();
				setShowSoftDeleteConfirmationModal(false);
			},
		});
	};

	return {
		user: getUserDataRequest?.data?.payload,
		isDataLoading: getUserDataRequest?.isLoading,
		refreshData,
		showSoftDeleteConfirmationModal,
		setShowSoftDeleteConfirmationModal,
		handleSoftDelete,
	};
};
